module.exports = __webpack_public_path__ + "static/blog02-bc84ab93bede9292571d47c1785d35a4.png";